"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var object_1 = require("../utils/object");
var MigrationTransform_1 = require("./transforms/MigrationTransform");
var MigrationEngine = /** @class */ (function () {
    function MigrationEngine(migrations) {
        this.migrations = migrations;
    }
    MigrationEngine.prototype.execute = function (data, sourceVersion, targetVersion) {
        if (sourceVersion === targetVersion) {
            console.warn("No applicable migrations, sourceVersion equals targetVersion, " + sourceVersion);
            return data;
        }
        var migrations = __spreadArrays(this.migrations);
        var sourceIndex = migrations.findIndex(function (migration) { return migration.version === sourceVersion; });
        var targetIndex = migrations.findIndex(function (migration) { return migration.version === targetVersion; });
        var direction = sourceIndex < targetIndex ? 'up' : 'down';
        if (direction === 'down') {
            migrations = migrations.reverse();
            sourceIndex = migrations.findIndex(function (migration) { return migration.version === sourceVersion; });
            targetIndex = migrations.findIndex(function (migration) { return migration.version === targetVersion; });
        }
        var applicableMigrations = migrations.filter(function (migration, migrationIndex) {
            if (direction === 'up') {
                return migrationIndex > sourceIndex && migrationIndex <= targetIndex;
            }
            if (direction === 'down') {
                return migrationIndex >= sourceIndex && migrationIndex < targetIndex;
            }
        });
        var response = object_1.deepMergeObjects({}, data);
        for (var _i = 0, applicableMigrations_1 = applicableMigrations; _i < applicableMigrations_1.length; _i++) {
            var migration = applicableMigrations_1[_i];
            var migrationTransforms = migration.transforms;
            var transforms = __spreadArrays(migrationTransforms);
            if (direction === 'down') {
                transforms = transforms.reverse();
            }
            for (var _a = 0, transforms_1 = transforms; _a < transforms_1.length; _a++) {
                var transform = transforms_1[_a];
                var migrationTransform = new MigrationTransform_1.MigrationTransform(transform);
                response = migrationTransform.execute(response, direction);
            }
        }
        return response;
    };
    return MigrationEngine;
}());
exports.MigrationEngine = MigrationEngine;
//# sourceMappingURL=MigrationEngine.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/migration/MigrationEngine.js
// module id = 742
// module chunks = 1